import React, { FC } from 'react';

import { ScoreType } from '../../../../../../store/admin/eventFormats/store';

import { getAppliedHandicap } from '../../../../../../Utils/getAppliedHandicap';
import { getClasses } from '../../../../../../Utils/getClasses';
import { useRoundScoreSummaryState } from '../../../../Context/RoundScoreSummary.context';
import {
  TPartials,
  useGetProcessedValues
} from '../../../../Hooks/useGetProcessedValues/useGetProcessedValues.hook';
import SummaryTableHeadRow from './Components/SummaryTableHeadRow';
import SummaryTableRow from './Components/SummaryTableRow';

export interface ISummaryTableProps {
  end?: number;
  formatIsStableford?: boolean;
  hideHandicapsRow?: boolean;
  partials?: TPartials;
  scoreType?: ScoreType;
  hideNet?: boolean;
  start?: number;
}

const SummaryTable: FC<ISummaryTableProps> = props => {
  const {
    end = 18,
    formatIsStableford,
    hideHandicapsRow,
    partials = [],
    scoreType,
    hideNet = false,
    start = 0
  } = props;

  const {
    grossWithAppliedHandicap,
    processedHandicaps,
    processedPars,
    processedGross,
    processedStablefords,
    processedNets
  } = useGetProcessedValues({
    end,
    partials,
    start
  });

  const { gross } = useRoundScoreSummaryState();

  const holes = Array.from(Array(end - start).keys())
    .map(h => String(1 + h + start))
    .reduce((acc: string[], hole: string, index: number) => {
      const partialNames = partials.filter(p => p.to === index + start).map(p => p.name);

      return partialNames ? [...acc, hole].concat(partialNames) : [...acc, hole];
    }, []);

  return (
    <table className="summary-table">
      <tbody>
        <SummaryTableHeadRow title="HOLE" values={holes} />

        {hideHandicapsRow && <SummaryTableHeadRow title="HCP" values={processedHandicaps} />}

        <SummaryTableHeadRow title="PAR" values={processedPars} />

        {(scoreType === ScoreType.GROSS || scoreType === undefined) && (
          <SummaryTableRow
            title="GRS"
            values={grossWithAppliedHandicap}
            getCellClassName={(h, index) =>
              `value-wrapper ${getClasses(processedPars, index, h[0], start === 0 && end === 18) +
                ' ' +
                getAppliedHandicap(h[1])}`
            }
          />
        )}

        {(scoreType === ScoreType.NET || scoreType === undefined) && !hideNet && (
          <SummaryTableRow
            title="NET"
            values={processedNets}
            getCellClassName={(h, index) =>
              `value-wrapper ${getClasses(
                processedPars,
                index,
                h as string,
                start === 0 && end === 18
              )}`
            }
          />
        )}

        {formatIsStableford && (
          <SummaryTableRow
            title="PTS"
            values={processedStablefords}
            getCellClassName={(_, index) =>
              `value-wrapper ${
                scoreType === ScoreType.GROSS || scoreType === undefined
                  ? getClasses(
                      processedPars,
                      index,
                      processedGross[index][0],
                      start === 0 && end === 18
                    ) +
                    ' ' +
                    getAppliedHandicap(gross[index][1])
                  : getClasses(
                      processedPars,
                      index,
                      processedNets[index],
                      start === 0 && end === 18
                    )
              }`
            }
          />
        )}
      </tbody>
    </table>
  );
};

export default SummaryTable;
